<template>
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.7168 4.24261L24.4742 0L14.3584 10.1158L4.24268 0L0 4.24261L10.1158 14.3584L0 24.4742L4.24268 28.7168L14.3584 18.601L24.4742 28.7168L28.7168 24.4742L18.601 14.3584L28.7168 4.24261Z" fill="white"/>
    </svg>
</template>

<script>
export default {
	name: "Times"
};
</script>
